import {Helmet} from "react-helmet-async";
import React, {lazy, Suspense} from 'react';

function HomePage() {

    const SellSection = lazy(() => import('./../sections/sell'));
    const FeatureBanner = lazy(() => import('./../banners/FeatureBanner'));
    const RentSection = lazy(() => import('./../sections/rent'));
    const LocationBanner = lazy(() => import('./../banners/LocationBanner'));
    const WoodenProducts = lazy(() => import('./../sections/wooden-products'));
    const TextBanner = lazy(() => import('./../banners/TextBanner'));

    return <>
        <Helmet>
            <title>Головна сторінка — Hlushman House</title>
            <meta name="title" content="Hlushman House - Головна сторінка"/>
            <meta name="description"
                  content="Ми поєднали сучасний комфорт та елегантний дизайн із величними панорами Карпат, кришталевим повітрям і тишею, про яку ви так довго мріяли. Це місце, де створюються спогади."/>
            <meta property="og:title" content="Головна сторінка — Hlushman House"/>
            <meta property="og:description"
                  content="Ласкаво просимо! Відкрийте для себе наші найкращі товари, послуги та актуальні пропозиції. Все найважливіше — в одному місці."/>
            <meta property="og:image" content="https://hlushman.site/img/logo.jpg"/>
            <meta property="og:url" content="https:///hlushman.site"/>
        </Helmet>

        <div className="min-h-screen bg-slate-50 text-slate-800 font-sans">

            <Suspense fallback={<div>Loading...</div>}>
                <SellSection />
            </Suspense>

            <Suspense fallback={<div>Loading...</div>}>
                <FeatureBanner />
            </Suspense>

            <Suspense fallback={<div>Loading...</div>}>
                <RentSection />
            </Suspense>

            <Suspense fallback={<div>Loading...</div>}>
                <LocationBanner />
            </Suspense>

            <Suspense fallback={<div>Loading...</div>}>
                <WoodenProducts />
            </Suspense>

            <Suspense fallback={<div>Loading...</div>}>
                <TextBanner />
            </Suspense>

        </div>


    </>;
}

export default HomePage;